<script>
  import 'vue-strap/dist/vue-strap-lang';
  import radio from '~componentes/Radio.vue';
  import { datepicker, checkbox } from 'vue-strap';

  export default {
    components: { checkbox, radio, datepicker },
    props: {
      itemSolicitacao: {
        required: true
      },
      manterObservacao: {
        default: true,
        type: Boolean,
      },
      produtos: {
        required: true
      },
      tiposProdutos: {
        required: true
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao()
      }
    },
    computed: {
      observacaoItemCompraContador: function() {
        let quantidadeCaracteres = this.itemSolicitacao.observacaoItemCompra ? 
            this.itemSolicitacao.observacaoItemCompra.length : 0;

        return 500 - quantidadeCaracteres;
      }
    },
    methods: {
      validar() {
        return this.$validator.validateAll();
      }
    },
    mounted() {
      this.$nextTick(() => {
        $('.datepicker input').attr('readonly', '');
      });
      this.itemSolicitacao.quantidade = 1;
    },
  }
</script>

<template>
    <div>
        <div class="row" v-if="configuracao.obrigatorioSelecionarProduto">
            <div class="col-md-12">
                <div class="form-group required" :class="{'has-error': errors.has('tipoProduto')}">
                    <label class="control-label" for="tipoProduto">Tipo de produto</label>

                    <select class="form-control"
                            id="tipoProduto"
                            v-model="itemSolicitacao.idTipoProduto"
                            data-vv-name="tipoProduto"
                            data-vv-as="tipo de produto"
                            v-validate="'required'">
                        <option value="">Selecione...</option>
                        <option :value="tipoProduto.idTipoProduto"
                                v-for="tipoProduto in tiposProdutos">
                            {{ tipoProduto.nomeTipoProduto }}
                        </option>
                    </select>

                    <p class="text-danger" v-show="errors.has('tipoProduto')">{{ errors.first('tipoProduto') }}</p>
                </div>
            </div>
        </div>

        <div class="row" v-if="configuracao.obrigatorioSelecionarProduto">
            <div class="col-md-12">
                <div class="form-group required" :class="{'has-error': errors.has('produto')}">
                    <label class="control-label" for="produto">Produto</label>

                    <select class="form-control"
                            id="produto"
                            v-model="itemSolicitacao.idProduto"
                            data-vv-name="produto"
                            data-vv-as="produto"
                            v-validate="'required'">
                        <option value="">Selecione...</option>
                        <option :value="produto.idProduto"
                                v-for="produto in produtos">
                            {{ produto.nome }}
                        </option>
                    </select>

                    <p class="text-danger" v-show="errors.has('produto')">{{ errors.first('produto') }}</p>
                </div>
            </div>
        </div>

        <p class="no-padding" v-if="configuracao.permitirSelecaoDespesasExtrasSolicitacaoCompraItemHotel"><b>Autoriza despesas com extras?</b></p>

        <div class="row" v-if="configuracao.permitirSelecaoDespesasExtrasSolicitacaoCompraItemHotel">
            <div class="col-xs-6">
                <div class="form-group">
                    <radio v-model="itemSolicitacao.despesasExtras"
                           selected-value="1"
                           type="success">
                        Sim, exceto frigobar e bebidas alcóolicas.
                    </radio>
                </div>
            </div>

            <div class="col-xs-6">
                <div class="form-group">
                    <radio v-model="itemSolicitacao.despesasExtras"
                           selected-value=""
                           type="success">
                        Não
                    </radio>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6">
                <div class="form-group" :class="{'has-error': errors.has('nomeHospede'), 'required': configuracao.obrigatorioNomeHospedeSolicitacaoCompraItemHotel}">
                    <label class="control-label" for="nome-hospede">Nome do hóspede</label>

                    <input type="text"
                           class="form-control"
                           id="nome-hospede"
                           v-model="itemSolicitacao.nomeHospede"
                           v-validate="`${configuracao.obrigatorioNomeHospedeSolicitacaoCompraItemHotel ? 'required' : ''}`"
                           data-vv-name="nomeHospede"
                           data-vv-as="nome do hóspede"
                           maxlength="100">

                    <p class="text-danger" v-show="errors.has('nomeHospede')">{{ errors.first('nomeHospede') }}</p>
                </div>
            </div>

            <div class="col-md-6">
                <div class="form-group" :class="{'has-error': errors.has('cpfHospede'), 'required': configuracao.obrigatorioCpfSolicitacaoCompraItemHotel}">
                    <label class="control-label" for="cpf-hospede">CPF do hóspede</label>

                    <input type="text"
                           class="form-control"
                           id="cpf-hospede"
                           v-model="itemSolicitacao.cpfHospede"
                           v-validate="`${configuracao.obrigatorioCpfSolicitacaoCompraItemHotel ? 'required|cpf' : 'cpf'}` "
                           data-vv-name="cpfHospede"
                           data-vv-as="cpf do hóspede"
                           v-mascara="'cpf'">

                    <p class="text-danger" v-show="errors.has('cpfHospede')">{{ errors.first('cpfHospede') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-6">
                <div class="form-group" :class="{'has-error': errors.has('telefoneHospede'), 'required': configuracao.obrigatorioTelefoneSolicitacaoCompraItemHotel}">
                    <label class="control-label" for="telefone-hospede">Telefone</label>

                    <input type="text"
                           class="form-control"
                           id="telefone-hospede"
                           v-model="itemSolicitacao.telefoneHospede"
                           v-validate="`${configuracao.obrigatorioTelefoneSolicitacaoCompraItemHotel ? 'required' : ''}`"
                           data-vv-name="telefoneHospede"
                           data-vv-as="telefone"
                           v-mascara="'telefone'">

                    <p class="text-danger" v-show="errors.has('telefoneHospede')">{{ errors.first('telefoneHospede') }}</p>
                </div>
            </div>

            <div class="col-xs-6">
                <div class="form-group" :class="{'has-error': errors.has('emailHospede'), 'required': configuracao.obrigatorioEmailSolicitacaoCompraItemHotel}">
                    <label class="control-label" for="email-hospede">E-mail</label>

                    <input type="text"
                           class="form-control"
                           id="email-hospede"
                           v-model="itemSolicitacao.emailHospede"
                           v-validate="`${configuracao.obrigatorioEmailSolicitacaoCompraItemHotel ? 'required' : ''}`"
                           data-vv-name="emailHospede"
                           data-vv-as="e-mail"
                           maxlength="100">

                    <p class="text-danger" v-show="errors.has('emailHospede')">{{ errors.first('emailHospede') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div :class="[configuracao.utilizarValorEstimado ? 'col-xs-8' : 'col-xs-12']">
                <div class="form-group" :class="{'has-error': errors.has('nomeHotel'), 'required': configuracao.obrigatorioNomeHotelSolicitacaoCompraItemHotel}">
                    <label class="control-label" for="nome-hotel">Nome do hotel e contato / cidade e estado de destino</label>

                    <input type="text"
                           class="form-control"
                           id="nome-hotel"
                           v-model="itemSolicitacao.nomeHotel"
                           v-validate="`${configuracao.obrigatorioNomeHotelSolicitacaoCompraItemHotel ? 'required' : ''}`"
                           data-vv-name="nomeHotel"
                           data-vv-as="nome do hotel e contato"
                           maxlength="100">

                    <p class="text-danger" v-show="errors.has('nomeHotel')">{{ errors.first('nomeHotel') }}</p>
                </div>
            </div>

            <div class="col-xs-4" v-if="configuracao.utilizarValorEstimado">
                <div class="form-group required" :class="{'has-error': errors.has('valorEstimado')}">
                    <label class="control-label" for="valor-estimado">Valor unitário estimado (R$)</label>

                    <input type="text"
                           class="form-control text-right"
                           id="valor-estimado"
                           v-model="itemSolicitacao.valorEstimado"
                           data-vv-name="valorEstimado"
                           v-validate="'required|not_zero'"
                           data-vv-as="valor estimado"
                           v-mascara="'moeda'">

                    <p class="text-danger" v-show="errors.has('valorEstimado')">{{ errors.first('valorEstimado') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-3">
                <div class="form-group required" :class="{'has-error': errors.has('dataCheckin')}">
                    <label class="control-label" for="data-checkin">Data do check in</label>

                    <datepicker v-model="itemSolicitacao.dataCheckin"
                                format="dd/MM/yyyy"
                                id="data-checkin"
                                placeholder="  /  /     "
                                lang="pt-BR"
                                data-vv-name="dataCheckin"
                                data-vv-as="data do check in"
                                v-validate="'required|date_format:DD/MM/YYYY'">
                    </datepicker>

                    <p class="text-danger" v-show="errors.has('dataCheckin')">{{ errors.first('dataCheckin') }}</p>
                </div>
            </div>

            <div class="col-md-3">
                <div class="form-group required" :class="{'has-error': errors.has('horaCheckin')}">
                    <label class="control-label" for="hora-checkin">Hora do check in</label>

                    <input type="text"
                           class="form-control"
                           id="hora-checkin"
                           v-model="itemSolicitacao.horaCheckin"
                           v-validate="'required|date_format:HH:mm'"
                           data-vv-name="horaCheckin"
                           data-vv-as="hora do check in"
                           v-mascara="'hora'">

                    <p class="text-danger" v-show="errors.has('horaCheckin')">{{ errors.first('horaCheckin') }}</p>
                </div>
            </div>

            <div class="col-md-3">
                <div class="form-group required" :class="{'has-error': errors.has('dataCheckout')}">
                    <label class="control-label" for="data-checkout">Data do check out</label>

                    <datepicker v-model="itemSolicitacao.dataCheckout"
                                format="dd/MM/yyyy"
                                id="data-checkout"
                                placeholder="  /  /     "
                                lang="pt-BR"
                                data-vv-name="dataCheckout"
                                data-vv-as="data do check out"
                                v-validate="'required|date_format:DD/MM/YYYY'">
                    </datepicker>

                    <p class="text-danger" v-show="errors.has('dataCheckout')">{{ errors.first('dataCheckout') }}</p>
                </div>
            </div>

            <div class="col-md-3">
                <div class="form-group required" :class="{'has-error': errors.has('horaCheckout')}">
                    <label class="control-label" for="hora-checkout">Hora do check out</label>

                    <input type="text"
                           class="form-control"
                           id="hora-checkout"
                           v-model="itemSolicitacao.horaCheckout"
                           v-validate="'required|date_format:HH:mm'"
                           data-vv-name="horaCheckout"
                           data-vv-as="hora do check out"
                           v-mascara="'hora'">

                    <p class="text-danger" v-show="errors.has('horaCheckout')">{{ errors.first('horaCheckout') }}</p>
                </div>
            </div>
        </div>

        <div class="row" v-if="!configuracao.solCompraOcultarObservacoes">
            <div class="col-xs-12">
                <div class="form-group">
                    <div class="checkbox">
                        <checkbox @checked="$emit('update:manterObservacao', !manterObservacao)" :value="manterObservacao" type="primary">
                            Manter observação do item de compra (caso esta solicitação
                            demandar outros itens com a mesma observação)
                        </checkbox>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-if="!configuracao.solCompraOcultarObservacoes">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="observacao-item-compra">Observação do item de compra ({{ observacaoItemCompraContador }})</label>

                    <textarea class="form-control"
                              id="observacao-item-compra"
                              v-model="itemSolicitacao.observacaoItemCompra"
                              maxlength="500">
          </textarea>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-compra/componentes/compartilhado/FormReservaDeHotel.vue